document.addEventListener("DOMContentLoaded", () => {

    const steps = document.querySelectorAll(".sensory-step");

    openSensoryStep(steps[0]);

    steps.forEach(step => {
        const header = step.querySelector(".sensory-step-header");
        header.addEventListener("click", () => {
            if (!header.classList.contains("is-disabled")) {
                openSensoryStep(step);
            }
        });
    });

    const nextButtons = document.querySelectorAll("[data-next-target]");
    nextButtons.forEach(btn => {
        btn.addEventListener("click", () => handleNextClick(btn));
    });

    const filterGroups = [
        {
            selector: '.sensory-option-btn',
            hiddenInputId: 'input-sensory-needs',
            outputListId: 'list-active-needs',
            activeClass: 'is-selected',
            parentStepSelector: '.sensory-step--needs'
        },
        {
            selector: '.sensory-age-btn',
            hiddenInputId: 'input-sensory-ages',
            outputListId: 'list-active-ages',
            activeClass: 'is-selected',
            parentStepSelector: '.sensory-step--age'
        },
        {
            selector: '.sensory-price-input',
            hiddenInputId: 'input-sensory-prices',
            outputListId: 'list-active-prices',
            activeClass: '',
            parentStepSelector: '.sensory-step--budget',
            isCheckbox: true
        }
    ];

    filterGroups.forEach(initFilterGroup);
    mainToggleButton()
    const mainToggleBtn = document.querySelector('.sensory-toggle');
    const mainWrapper = document.querySelector('.sensory-picker-wrapper');

    if (mainToggleBtn && mainWrapper) {
        mainToggleBtn.addEventListener('click', (e) => {
            e.preventDefault();
            mainToggleBtn.classList.toggle('is-open');
            mainWrapper.classList.toggle('is-visible');
            mainToggleBtn.blur();
        });
    }
});

function mainToggleButton() {
    const mainToggleBtn = document.querySelector('.sensory-toggle');
    if (mainToggleBtn) {
        mainToggleBtn.classList.add('is-ready');
    }
}
function initFilterGroup(group) {
    const elements = document.querySelectorAll(group.selector);
    const hiddenInput = document.getElementById(group.hiddenInputId);

    let chosenValues = [];
    let chosenLabels = [];

    const eventType = group.isCheckbox ? 'change' : 'click';

    elements.forEach(el => {
        el.addEventListener(eventType, () => {
            const { value, label } = getElementData(el, group);

            if (chosenValues.includes(value)) {
                const idx = chosenValues.indexOf(value);
                chosenValues.splice(idx, 1);
                chosenLabels.splice(idx, 1);
                if (group.activeClass) el.classList.remove(group.activeClass);
            } else {
                chosenValues.push(value);
                chosenLabels.push(label);
                if (group.activeClass) el.classList.add(group.activeClass);
            }

            hiddenInput.value = chosenValues.join(',');

            toggleNextButton(group.parentStepSelector, chosenValues.length > 0);

            renderHeaderLabels(chosenLabels, group.outputListId);

            checkStepsAvailability();
        });
    });
}

function getElementData(el, group) {
    if (group.isCheckbox) {
        const labelSpan = el.closest('label').querySelector('.label-text');
        return {
            value: el.value,
            label: labelSpan ? labelSpan.textContent.trim() : el.value
        };
    }
    return {
        value: el.dataset.value || el.dataset.icon,
        label: el.dataset.label
    };
}

function openSensoryStep(targetStep) {
    const allSteps = document.querySelectorAll(".sensory-step");

    allSteps.forEach(step => {
        step.classList.remove("is-active");
        step.querySelector(".sensory-step-content").style.maxHeight = "0";
    });

    targetStep.classList.add("is-active");
    const content = targetStep.querySelector(".sensory-step-content");
    content.style.maxHeight = content.scrollHeight + "px";
}

function renderHeaderLabels(labels, listId) {
    const maxVisible = 2;
    const listContainer = document.getElementById(listId);
    listContainer.innerHTML = "";

    labels.slice(0, maxVisible).forEach(text => {
        const li = document.createElement("li");
        li.className = "sensory-selected-item";
        li.textContent = text;
        listContainer.appendChild(li);
    });

    if (labels.length > maxVisible) {
        const moreLi = document.createElement("li");
        moreLi.className = "sensory-selected-item";
        moreLi.textContent = "...";
        listContainer.appendChild(moreLi);
    }
}

function toggleNextButton(stepSelector, hasSelection) {
    const step = document.querySelector(stepSelector);
    const nextBtn = step ? step.querySelector("[data-next-target]") : null;

    if (!nextBtn) return;

    if (hasSelection) {
        nextBtn.removeAttribute("disabled");
    } else {
        nextBtn.setAttribute("disabled", "");
    }
}

function handleNextClick(btn) {
    const targetClassPart = btn.dataset.nextTarget;
    if (!targetClassPart) return;

    const nextStep = document.querySelector(`.sensory-step--${targetClassPart}`);
    if (nextStep) {
        openSensoryStep(nextStep);
    }
}

function checkStepsAvailability() {
    const dependencies = [
        {
            inputId: 'input-sensory-needs',
            targetStepSelector: '.sensory-step--age'
        },
        {
            inputId: 'input-sensory-ages',
            targetStepSelector: '.sensory-step--budget'
        }
    ];

    dependencies.forEach(dep => {
        const input = document.getElementById(dep.inputId);
        const targetStepHeader = document.querySelector(`${dep.targetStepSelector} .sensory-step-header`);

        if (!input || !targetStepHeader) return;

        if (input.value.trim() !== "") {
            targetStepHeader.classList.add('is-clickable');
            targetStepHeader.classList.remove('is-disabled');
        } else {
            targetStepHeader.classList.remove('is-clickable');
            targetStepHeader.classList.add('is-disabled');
        }
    });
}

const AGE_MAP = {
    "0-18_months.svg": "gid://shopify/Metaobject/209626693914",
    "18-36_months.svg": "gid://shopify/Metaobject/209626726682",
    "3-5_years.svg":   "gid://shopify/Metaobject/209626759450",
    "5-12_years.svg":  "gid://shopify/Metaobject/209626792218",
    "Teen.svg":        "gid://shopify/Metaobject/209626857754",
    "Adult.svg":       "gid://shopify/Metaobject/209626824986"
};

const SENSORY_MAP = {
    "Tactile": [
        "gid://shopify/Metaobject/209639768346",
        "gid://shopify/Metaobject/209639801114"
    ],
    "Fine Motor": "gid://shopify/Metaobject/209639571738",
    "Learning Tools": "gid://shopify/Metaobject/209639506202",
    "Movement & Balance": "gid://shopify/Metaobject/209639604506",
    "Calming & Regulation": "gid://shopify/Metaobject/209639637274",
    "Visual": "gid://shopify/Metaobject/209639866650",
    "Social Emotional": "gid://shopify/Metaobject/209639735578",
    "Travel": "gid://shopify/Metaobject/209639833882",
    "Oral Motor": "gid://shopify/Metaobject/209639670042",
    "Sleep": "gid://shopify/Metaobject/209639702810"
};

const PRICE_MAP = {
    "under-20": { min: 0, max: 20 },
    "20-50":    { min: 20, max: 50 },
    "50-100":   { min: 50, max: 100 },
    "100-200":  { min: 100, max: 200 },
    "over-200": { min: 200, max: null }
};


function buildShopifyUrl() {
    const baseUrl = '/collections/all'
    const params = new URLSearchParams();
    params.append('sort_by', 'best-selling')
    // 1. Process SENSORY Inputs
    const sensoryInput = document.getElementById('input-sensory-needs').value;
    if (sensoryInput) {
        const selectedSensory = sensoryInput.split(',');
        selectedSensory.forEach(key => {
            const val = SENSORY_MAP[key];
            if (Array.isArray(val)) {
                val.forEach(id => params.append('filter.p.m.amitech_meta_field.help_with_solutions', id));
            } else if (val) {
                params.append('filter.p.m.amitech_meta_field.help_with_solutions', val);
            }
        });
    }

    // 2. Process AGE Inputs
    const ageInput = document.getElementById('input-sensory-ages').value;
    if (ageInput) {
        const selectedAges = ageInput.split(',');
        selectedAges.forEach(key => {
            const gid = AGE_MAP[key];
            if (gid) {
                params.append('filter.p.m.amitech_meta_field.fun_age', gid);
            }
        });
    }

    // 3. Process PRICE Inputs
    const priceInput = document.getElementById('input-sensory-prices').value;
    if (priceInput) {
        const selectedPrices = priceInput.split(',');

        let globalMin = null;
        let globalMax = null;
        let hasOver200 = false;

        selectedPrices.forEach(key => {
            const range = PRICE_MAP[key];
            if (range) {
                if (globalMin === null || range.min < globalMin) globalMin = range.min;
                if (range.max === null) hasOver200 = true;
                else if (globalMax === null || range.max > globalMax) globalMax = range.max;
            }
        });

        if (globalMin !== null) params.append('filter.v.price.gte', globalMin);
        if (globalMax !== null && !hasOver200) params.append('filter.v.price.lte', globalMax);
    }
    return `${baseUrl}?${params.toString()}`;
}

document.addEventListener("DOMContentLoaded", () => {
    const finalButton = document.querySelector("[data-next-target='finish']");

    if(finalButton) {
        finalButton.addEventListener("click", (e) => {
            e.preventDefault();
            const url = buildShopifyUrl();
            window.location.href = url;
        });
    }
});